import axios from 'axios'
import UrlJoin from 'url-join'

import { ApiPrefix } from './Var.js'

axios.defaults.withCredentials = true

/* login */
const login = 'passport'

export const loginAdmin = data => axios.post(UrlJoin(ApiPrefix, login, 'admin'), data)
export const loginUser = data => axios.post(UrlJoin(ApiPrefix, login), data)
export const logout = () => axios.delete(UrlJoin(ApiPrefix, login, 'state'))
export const PostCheckUsername = data => axios.post(UrlJoin(ApiPrefix, login, 'check-username'), data)
export const loginState = () => axios.get(UrlJoin(ApiPrefix, login, 'state'))
export const postUser = data => axios.post(UrlJoin(ApiPrefix, login, 'new'), data)
export const getUserById = id => axios.get(UrlJoin(ApiPrefix, login, 'user', id))
export const getUser = param => axios.get(UrlJoin(ApiPrefix, login, 'user', `list${param}`))
export const putUserInfo = (data, id) => axios.put(UrlJoin(ApiPrefix, login, 'user', id), data)
export const delUser = id => axios.delete(UrlJoin(ApiPrefix, login, 'user', id))

export const urlUserSheet = format => UrlJoin(ApiPrefix, login, 'user', 'list', 'download', `?format=${format}`)

/* personal */
export const restPWd = id => axios.put(UrlJoin(ApiPrefix, login, 'user', id, 'pwd', 'renew'))
export const putPersonal = data => axios.put(UrlJoin(ApiPrefix, 'personal', 'user', 'update'), data)
export const putPersonalPwd = data => axios.put(UrlJoin(ApiPrefix, 'personal', 'user', 'pwd'), data)
export const putPersonalAdmin = data => axios.put(UrlJoin(ApiPrefix, 'personal', 'admin', 'update'), data)
export const putPersonalAdminPwd = data => axios.put(UrlJoin(ApiPrefix, 'personal', 'admin', 'pwd'), data)
export const postCart = data => axios.post(UrlJoin(ApiPrefix, 'personal', 'cargo'), data)
export const putCart = data => axios.put(UrlJoin(ApiPrefix, 'personal', 'cargo'), data)
export const getCart = () => axios.get(UrlJoin(ApiPrefix, 'personal', 'cargo'))

/* category */
const classify = 'classify'

export const getClassifyMain = () => axios.get(UrlJoin(ApiPrefix, classify))
export const getClassifySub = id => axios.get(UrlJoin(ApiPrefix, classify, id))
export const getClassifyItem = (id, query) => axios.get(UrlJoin(ApiPrefix, classify, id, 'items', query))
export const putCate = data => axios.put(UrlJoin(ApiPrefix, classify, data.id), data)
export const delCate = data => axios.delete(UrlJoin(ApiPrefix, classify, data.id))
export const putCateSort = data => axios.put(UrlJoin(ApiPrefix, classify, 'sort'), data)
export const postCate = data => axios.post(UrlJoin(ApiPrefix, classify), data)

/* catalog */
const prod = 'catalog'

export const postProd = data => axios.post(UrlJoin(ApiPrefix, prod), data)
export const getProd = id => axios.get(UrlJoin(ApiPrefix, prod, id))
export const getProdParam = param => axios.get(UrlJoin(ApiPrefix, prod, 'find', param))
export const getProdParamName = (name, param) => axios.get(UrlJoin(ApiPrefix, prod, 'find', name, param))
export const putProd = (data, id) => axios.put(UrlJoin(ApiPrefix, prod, id), data)
export const delProd = id => axios.delete(UrlJoin(ApiPrefix, prod, id))
export const putImg = (data, id) => axios.put(UrlJoin(ApiPrefix, prod, id, 'pic'), data, {headers: { 'Content-Type': 'multipart/form-data' }})
export const postEditorImg = (data, id) => axios.put(UrlJoin(ApiPrefix, prod, 'editor', 'img', 'upload', id), data, {headers: { 'Content-Type': 'multipart/form-data' }})
export const subSize = (cid, sid, amount) => axios.put(UrlJoin(ApiPrefix, prod, cid, 'size', sid, 'off', amount))
export const addSize = (cid, sid, amount) => axios.put(UrlJoin(ApiPrefix, prod, cid, 'size', sid, 'purch', amount))
export const delSize = (cid, sid) => axios.delete(UrlJoin(ApiPrefix, prod, cid, 'size', sid))
export const catalogImageLink = (cid, pid) => UrlJoin(ApiPrefix, prod, cid, 'pic', pid)
// export const catalogEditorImageLink = (cid, fid) => UrlJoin(ApiPrefix, prod, cid, 'editor', 'file', fid)
export const catalogThumbImageLink = (cid, pid) => UrlJoin(ApiPrefix, prod, cid, 'pic', pid, 'thumb')

const ads = 'ads'

export const postAds = data => axios.post(UrlJoin(ApiPrefix, ads), data, {headers: { 'Content-Type': 'multipart/form-data' }})
export const getAds = () => axios.get(UrlJoin(ApiPrefix, ads, 'list'))
export const putAds = (data, id) => axios.put(UrlJoin(ApiPrefix, ads, id), data, {headers: { 'Content-Type': 'multipart/form-data' }})
export const putAdsSeq = data => axios.put(UrlJoin(ApiPrefix, ads, 'seq'), data)
export const delAds = id => axios.delete(UrlJoin(ApiPrefix, ads, id))
export const adsImageLink = id => UrlJoin(ApiPrefix, ads, id, 'pic')

const favor = 'favor'

export const postFavor = data => axios.post(UrlJoin(ApiPrefix, favor), data)
export const getFavor = () => axios.get(UrlJoin(ApiPrefix, favor, 'list'))
export const putFavor = (data, id) => axios.put(UrlJoin(ApiPrefix, favor, id), data)
export const putFavorItems = (data, id) => axios.put(UrlJoin(ApiPrefix, favor, id, 'product'), data)
export const delFavor = id => axios.delete(UrlJoin(ApiPrefix, favor, id))

const deliver = 'deliver'

export const postDel = data => axios.post(UrlJoin(ApiPrefix, deliver, 'personal'), data)
export const getDel = query => axios.get(UrlJoin(ApiPrefix, deliver, 'list', query))
export const getMyDel = param => axios.get(UrlJoin(ApiPrefix, deliver, `personal`, 'list', param))
export const getMyDelDetail = id => axios.get(UrlJoin(ApiPrefix, deliver, 'personal', id))
export const getDelDetail = id => axios.get(UrlJoin(ApiPrefix, deliver, id))
export const delDel = id => axios.delete(UrlJoin(ApiPrefix, deliver, 'ctrl', id))
export const putDel = (id, state) => axios.put(UrlJoin(ApiPrefix, deliver, 'ctr', id, state))

export const urlDeliverOutput = query => UrlJoin(ApiPrefix, deliver, 'list', 'output', query)
export const urlDeliverDetail = (id, query) => UrlJoin(ApiPrefix, deliver, id, query)

const admin = 'admin'

export const getAdmin = query => axios.get(UrlJoin(ApiPrefix, admin, 'list', query))
export const postAdmin = data => axios.post(UrlJoin(ApiPrefix, admin), data)
export const delAdmin = id => axios.delete(UrlJoin(ApiPrefix, admin, id))
export const putAdmin = (data, id) => axios.put(UrlJoin(ApiPrefix, admin, id), data)
export const getAdminPwd = id => axios.put(UrlJoin(ApiPrefix, admin, id, 'reset-pwd'))

const config = 'config'

export const getConfig = () => axios.get(UrlJoin(ApiPrefix, config))
export const getFooter = () => axios.get(UrlJoin(ApiPrefix, config, 'footer'))
export const putConfig = data => axios.put(UrlJoin(ApiPrefix, config), data)

const statistic = 'statistic'
const statisticR = 'statistic/remider'
const statisticW = 'statistic/weekly'

export const getOutofDate = () => axios.get(UrlJoin(ApiPrefix, statisticR, 'out-of-date'))
export const getCredited = () => axios.get(UrlJoin(ApiPrefix, statisticR, 'credited'))
export const getDelivering = () => axios.get(UrlJoin(ApiPrefix, statisticR, 'delivering'))
export const getOutofAmount = () => axios.get(UrlJoin(ApiPrefix, statisticR, 'out-of-amount'))
export const getNewUser = () => axios.get(UrlJoin(ApiPrefix, statisticW, 'new-user'))
export const getViwer = () => axios.get(UrlJoin(ApiPrefix, statisticW, 'viewer'))
export const getCount = () => axios.get(UrlJoin(ApiPrefix, statisticW, 'deliver', 'count'))
export const getSale = () => axios.get(UrlJoin(ApiPrefix, statisticW, 'deliver', 'total-price'))

export const GetDailyDeliverCount = query => axios.get(urlDailyDeliverCount(query))
export const GetDailyAmountCount = query => axios.get(urlDailyAmountCount(query))
export const GetClassifyCount = query => axios.get(urlClassifyCount(query))
export const GetCatalogCale = query => axios.get(urlCatalogCale(query))
export const GetDeliverCale = query => axios.get(urlDeliverCale(query))
export const GetDeliverPrice = query => axios.get(urlDeliverPrice(query))
export const postOpsRecords = data => axios.post(UrlJoin(ApiPrefix, statistic, 'op', 'records'), data)

export const urlDailyDeliverCount = query => UrlJoin(ApiPrefix, statistic, 'daily', 'delivers', 'count', query)
export const urlDailyAmountCount = query => UrlJoin(ApiPrefix, statistic, 'daily', 'delivers', 'sum', query)
export const urlClassifyCount = query => UrlJoin(ApiPrefix, statistic, 'classify', 'cale', query)
export const urlCatalogCale = query => UrlJoin(ApiPrefix, statistic, 'catalog', 'cale', query)
export const urlDeliverCale = query => UrlJoin(ApiPrefix, statistic, 'deliver', 'cale', query)
export const urlDeliverPrice = query => UrlJoin(ApiPrefix, statistic, 'deliver', 'price', query)